import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

const useRemoveCarrier = (carrierId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<void>({
    path: `/api/businesses/${business.id}/carriers/${carrierId}`,
    method: HttpMethod.DELETE,
  }, options);
}

export default useRemoveCarrier;
